import React from "react";

interface ChevronDoubleRightIconProps {
  className?: string;
}

export const ChevronDoubleRightIcon: React.FC<ChevronDoubleRightIconProps> = ({
  className = "w-5 h-5",
}) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13 5l7 7-7 7M5 5l7 7-7 7"
      />
    </svg>
  );
};

